import React, { Component } from 'react';
import Startbtn from './startbtn.jsx'
import Inputchange from './inputchange.jsx'
import Timercomponent from './timercomponent'
import Manualcomponent from './manualcomponent'

class Headbar extends Component {

  render() {
    const {timer, addManualRecord, setActiveRecordTitle, selectActiveProject, stopRecord, startRecord, addRecord, updateActiveRecordStart} = this.props
    return (
      <div className="headbar">
          { timer.manual === false ? (
            <Timercomponent updateActiveRecordStart={updateActiveRecordStart} setActiveRecordTitle={setActiveRecordTitle} selectRecordProject={selectActiveProject} timer={timer}>
              <Startbtn start={startRecord} add={addRecord} stop={stopRecord} active={timer.active_record} timer_loading={timer.timer_loading}/>
            </Timercomponent>
          ):(
            <Manualcomponent timer_loading={timer.timer_loading} addManualRecord={addManualRecord} manual_record={timer.manual_record} />
          )}
          <Inputchange active={timer.active_record} manual = {timer.manual} toggle = {this.props.toggleTimerMode} delete = {this.props.deleteActiveRecord}/>
      </div>
    );
  }
}

export default Headbar;
